import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Home/header";
import Promotion from "../Home/Promotion";
import HomePageProductLists from "./HomePageProductLists";
import Footer from "../Home/footer";
import WaveAnimation from "./wawe";
import MobileAppinstruction from "./MobileAppinstruction";


function AC() {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const modelType = params.get('model');

        if (modelType) {
            setTimeout(() => {
                const element = document.getElementById(modelType);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100); // Sayfanın yüklenmesi için kısa bir gecikme ekledik
        }
    }, [location]);

    return (
        <div className="App">
            <Header />
            <Promotion
                Header="AC İstasyonlar"
                Footer="AC şarj istasyonlarımız, ticari ve konut alanlarındaki elektrikli araç şarj ihtiyaçlarınız"
                Footer2="ekonomik ve verimli biçimde karşılamak üzere tasarlanmıştır."
            />
            <HomePageProductLists />
            <WaveAnimation />
            <MobileAppinstruction />
            <Footer />
        </div>
    );
}

export default AC;